import React from 'react'
import { concatStyles } from 'utils'

export interface ITab {
  disabled?: boolean
  label: string
  value: string
}

type MaybeTab = ITab | null | undefined

export interface ITabsProps {
  tabs: MaybeTab[]
  currentValue: string
  onSelectTab: (tab: ITab) => void
  className?: string
  style?: React.CSSProperties
}

const TABS_CONTAINER_STYLES =
  'font-heading font-bold flex flex-wrap justify-start border border-contentareaborder bg-contentareabackgroundalt'
const TAB_STYLES =
  'my-0 mx-0 px-5 py-3 text-sm cursor-pointer focus:outline-none uppercase transition-colors border-r border-contentareaborder last:border-r-0'
const DISABLED_STYLES =
  'text-contentareaborder pointer-events-none bg-contentareabackgroundalt'
const SELECTED_TAB = 'bg-secondary text-white'
const DESELECTED_TAB =
  'bg-contentareabackgroundalt text-secondary hover:bg-actionable hover:text-secondary'

export const Tabs: React.FC<ITabsProps> = ({
  currentValue,
  tabs,
  onSelectTab: handleSelect,
  className,
  style,
}) => (
  <div
    className={concatStyles([TABS_CONTAINER_STYLES, className])}
    style={style}
  >
    {tabs
      .filter((t) => t)
      .map((t) => t as ITab)
      .map((tab, _) => {
        const { disabled } = tab
        const selected: boolean = currentValue === tab.value
        const onClick: React.MouseEventHandler = () => handleSelect(tab)

        return (
          <button
            key={tab.value}
            onClick={onClick}
            className={concatStyles([
              TAB_STYLES,
              disabled ? DISABLED_STYLES : '',
              selected ? SELECTED_TAB : DESELECTED_TAB,
            ])}
          >
            {tab.label}
          </button>
        )
      })}
  </div>
)

Tabs.displayName = 'Content.Tabs'
